var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "show-close": true,
        "custom-class": "zyyj-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleOpen
      }
    },
    [
      _c(
        "div",
        { attrs: { id: "login-container" } },
        [
          _c("span", { staticClass: "forget-pass" }, [_vm._v("登录密码更改")]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              key: "passForm",
              ref: "passForm",
              staticClass: "login-form",
              attrs: {
                model: _vm.passForm,
                rules: _vm.passRule,
                "label-position": "top"
              }
            },
            [
              _c(
                "el-form-item",
                { key: "password", attrs: { prop: "password" } },
                [
                  _c(
                    "label",
                    { staticClass: "common-label", attrs: { for: "password" } },
                    [_vm._v("新密码")]
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "auto-complete": "off",
                      maxlength: 20,
                      placeholder: "请输入新密码"
                    },
                    model: {
                      value: _vm.passForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.passForm, "password", $$v)
                      },
                      expression: "passForm.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { key: "checkPassword", attrs: { prop: "checkPassword" } },
                [
                  _c(
                    "label",
                    {
                      staticClass: "common-label",
                      attrs: { for: "checkPassword" }
                    },
                    [_vm._v("确认新密码")]
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      id: "checkPassword",
                      "auto-complete": "off",
                      maxlength: 20,
                      placeholder: "请再次输入新密码"
                    },
                    model: {
                      value: _vm.passForm.checkPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.passForm, "checkPassword", $$v)
                      },
                      expression: "passForm.checkPassword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "button", staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "next-button",
                      attrs: { type: "primary" },
                      on: { click: _vm.checkPwd }
                    },
                    [_vm._v("重新登录")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1c7fb45b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1c7fb45b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/change-pass-editor/change-pass-editor.vue
// module id = null
// module chunks = 